import Breadcrumb from "@/components/BreadCrumb";
import Layout from "@/components/layout";
import Head from "next/head";
import Image from "next/image";
import React from "react";

const constants = [
  {
    head: "Course Description:",
    text: "The Course is designed to provide educational content about trading techniques, FNO trading, coding using Python, and executing trades using Excel. The Course is intended for educational purposes only and does not constitute financial or investment advice. The Instructor does not guarantee any specific results or profits from trading activities.",
  },
  {
    head: "Indemnification:",
    text: "By enrolling in the Course, you acknowledge and agree to indemnify and hold the Instructor harmless against any and all claims, damages, losses, liabilities, costs, and expenses (including attorney's fees) incurred by the Instructor arising out of or in connection with:",
    indents: [
      "Any losses incurred by you in trading activities, whether or not influenced by the Course.",
      "Any losses resulting from technology errors, including but not limited to technical glitches, system failures, failure of python codes, failure of excel usage or other technical issues.",
      "The non-refundable nature of the Course fee, and the understanding that no refunds will be provided after the Course commencement.",
      "The understanding that any backtested strategy results presented during the Course do not guarantee future profits or outcomes.",
    ],
  },
  {
    head: "No Financial Guarantee:",
    text: "The Instructor makes no representations or warranties regarding the profitability or success of any trading strategies or techniques discussed during the Course. You understand and acknowledge that trading activities involve inherent risks, and any decisions or actions taken based on the Course content are at your own discretion and risk.",
  },
  {
    head: "Use of Sample Code:",
    text: "The Instructor may provide sample code during the Course for learning purposes only. The sample code is not intended as a recommendation or endorsement of any specific trading strategies or techniques. You agree to use the sample code solely for educational purposes and understand that the Instructor does not provide a tip-providing service or code.",
  },
  {
    head: "Market Risks:",
    text: "You understand and acknowledge that option trading and automatic API trading are subject to market risks. The Instructor shall not be held liable for any losses incurred due to market volatility, fluctuations, or any other market-related factors.",
  },
  {
    head: "Intellectual Property:",
    text: "All Course materials, including but not limited to text, graphics, videos, and code, are the intellectual property of the Instructor and protected by applicable copyright laws. You agree not to reproduce, distribute, or share any Course materials without prior written permission from the Instructor.",
  },
  {
    head: "Governing Law and Jurisdiction:",
    text: "This Agreement shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.",
  },
  {
    head: "Disclosure:",
    text: "I am not a SEBI registered Advisor, and I do not possess any Research Analyst or Investment Advisor license. By enrolling in this course, you acknowledge and agree that you are undertaking the course at your own responsibility. You understand that any information or guidance provided during the course is for educational purposes only and should not be construed as financial advice or recommendations for investment decisions. You are solely responsible for any actions you take based on the knowledge and skills acquired through the course.",
  },
];

const TermsAndConditions = () => {
  return (
    <>
      <Head>
        <title>Terms & Conditions | Tradewise</title>
        <meta
          name="description"
          content="Read Tradewise's Terms & Conditions to understand our services, payment terms, intellectual property policies, and user responsibilities."
        />
      </Head>
      <Layout>
        <Breadcrumb />
        <div className="max-w-[700px] mx-auto">
          <h1 className="text-3xl font-bold leading-[22px] tracking-[0.25px] my-6">
            Terms and Conditions
          </h1>
          <p>
            This agreement ("Agreement") is entered into between [TFU and Aseem
            Singhal] ("Instructor" or "We") and yourself ("Student" or "You") in
            connection with your enrollment in the online trading and coding
            course offered by the Instructor. By enrolling in the Course, you
            acknowledge and agree to be bound by the terms and conditions of
            this Agreement.
          </p>
          {constants.map((item, index) => (
            <div key={index} className="mt-4">
              <h3 className="flex gap-2 text-xl tracking-[0.25px] mt-6 items-center">
                <Image
                  src="/checkbox.svg"
                  width={18}
                  height={18}
                  alt="bullet icon"
                  className="min-w-[22px] h-fit"
                />
                {item.head}
              </h3>
              <p className="mt-4">{item.text}</p>

              <ol className="list-decimal list-inside mt-4">
                {item.indents?.map((item, index) => (
                  <li key={index} className="mt-2">
                    {item}
                  </li>
                ))}
              </ol>
            </div>
          ))}
          <p className="mb-6">
            By enrolling in the Course, you acknowledge that you have read and
            understood the terms and conditions of this Agreement. You agree to
            comply with all the obligations and responsibilities outlined
            herein.
          </p>
        </div>
      </Layout>
    </>
  );
};

export default TermsAndConditions;
